<template>
  <div class="page">
    <Navigation pageName="restores" />
    <!--FILTRI E RICERCA-->
    <div class="filter-section">
      <div class="filter-left">
        <label class="text-bold">{{ $t("Search") }}</label>
        <input
          type="text"
          class="input bg-white pl-4 text-small"
          v-model.trim="filters.restoreName"
          :placeholder="$t('Search for restore name')"
          v-fsitem
          />
      </div>
      <!-- Groups -->
      <div class="filter-left">
        <label class="text-bold">{{ $t("Group") }}</label>
        <select
          class="bg-white pl-2 select text-small"
          data-filter="false"
          v-model="filters.groupSelected"
          @change="setGroupPCs()"
          >
          <option value="">{{ $t("All Groups") }}</option>
          <option
            v-for="group in groups" 
            :value="group"
            :key="group.id_group"
            >
            {{ group.name_group }}
          </option>
        </select>
      </div>
      <!-- Devices (enabled only when a group is selected) -->
      <div class="filter-left">
        <label class="text-bold">{{ $t("Device") }}</label>
        <select
          :disabled="!filters.groupSelected"
          v-disable-tooltip="$t('Select a group to select a device')"
          class="bg-white pl-2 select text-small"
          data-filter="false"
          v-model="filters.id_pc"
          >
          <option value="">{{ $t('All Devices') }}</option>
          <option
            v-for="pc in groupPCs" 
            :value="pc.id"
            :key="pc.id"
            >
            {{ pc.pc_name }}
          </option>
        </select>
      </div>
      <!-- Result (fix order: (value, key)) -->
      <div class="filter-left">
        <label class="text-bold">{{ $t("Result") }}</label>
        <select class="bg-white pl-2 select text-small" v-model="filters.result">
          <option value="">{{ $t('All results') }}</option>
          <option
            v-for="value in filters.resultList"
            :value="value"
            :key="value"
            >
            {{ $t(value.getResultValueInfo().label) }}
          </option>
        </select>
      </div>
      <!-- Limit -->
      <div class="filter-left">
        <label class="text-bold">{{ $t("N. of rows") }}</label>
        <select class="bg-white pl-2 select text-small" v-model.number="filters.limit">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>
      <!-- Apply filters -->
      <div class="filter-left d-flex flex-align-end">
        <button @click="getRestores()" class="button secondary">
        {{ $t('Filter') }}
        </button>
      </div>
    </div>
    <div class="pl-5 pb-5">
      <small>{{ $t("Restore operations are stored and automatically removed after 30 days.") }}</small>
    </div>
    <!--RISULTATI-->
    <div class="results-section">
      <NoDataAvailable
        v-if="restores != null && restores.length == 0"
        :message="$t('No restores available')"
        />
      <table
        v-if="restores != null && restores.length != 0"
        id="restore-list"
        class="striped compact table w-100 bg-white bordered border overflow"
        >
        <thead>
          <tr class="mb-3">
            <th class="text-center" style="vertical-align: middle;">
              {{ $t('Result') }}
            </th>
            <th class="text-left" style="vertical-align: middle; width: 150px;">
              {{ $t('Restore name') }}
            </th>
            <th class="text-left" style="vertical-align: middle;">
              {{ $t('Device') }}
            </th>
            <th class="text-right w-fit" style="vertical-align: middle;">{{ $t("Source Type") }}</th>
            <th class="text-right w-fit" style="vertical-align: middle;">{{ $t("Destination Type") }}</th>
            <th class="text-right" style="vertical-align: middle; white-space: nowrap;">
              {{ $t('Started') }}/{{ $t('Ended') }}/{{ $t('Duration') }}
            </th>
            <th class="text-center" style="vertical-align: middle; white-space: nowrap;">
              {{ $t('N. of files') }}
            </th>
            <th class="text-center" style="vertical-align: middle;">
              {{ $t('Size') }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(restore, index) in restores" :key="index">
            <td class="text-center">
              <LastResult :lastresult="restore.restore_result" />
            </td>
            <td class="text-left overflow">
              <label
                :title="restore.restore_name"
                class="button flat-button text-bold"
                @click="openRestoreView(restore, index)"
                >
              {{ restore.restore_name.length > 50 ? restore.restore_name.substring(0, 50) + '...' : restore.restore_name }}
              </label>
            </td>
            <td class="text-left">
              <PCLink
                v-if="$session.getPCWithID(restore.id_computer) != null"
                :pc="$session.getPCWithID(restore.id_computer)"
                :seeHealth="true"
                :seeConnectionStatus="true"
                />
            </td>
            <td class="text-right w-fit">
              <span v-if="restore.source_properties.type" class="badge inline tertiary">
              {{ $ONEServiceTypeInfo[restore.source_properties.type].name.toUpperCase() }}
              </span>
            </td>
            <td class="text-right w-fit">
              <span v-if="restore.destination_properties.type" class="badge inline tertiary">
              {{ $ONEServiceTypeInfo[restore.destination_properties.type].name.toUpperCase() }}
              </span>
              <span v-else-if="restore.type" class="badge inline tertiary">
              {{ $ONEServiceTypeInfo[restore.type].name.toUpperCase() }}
              </span>
            </td>
            <td class="text-right">
              <label v-if="restore.dt_start_utc">{{ restore.dt_start_utc.toLocalDate() }}</label>
              <br />
              <label v-if="restore.dt_end_utc">{{ restore.dt_end_utc.toLocalDate() }}</label>
              <br />
              <label class="text-bold" v-if="restore.dt_end_utc">
              {{ diffDate(restore.dt_start_utc, restore.dt_end_utc) }}
              </label>
            </td>
            <td class="text-center">
              {{ restore.processed_files }}
            </td>
            <td class="text-center">
              {{ restore.processed_data | prettyBytes }}
            </td>
            <td class="no-wrap pos-relative">
              <button class="button dropdown-toggle"><span
                class="mif-2x mif-menu"></span>
              </button>
              <ul class="d-menu border drop-left bg-white mt-2" data-role="dropdown">
                <li><a href="#" @click="openRestoreView(restore, index)" :title="$t('Restore job details')"><span class="mif-eye icon"></span> {{ $t("View") }}</a></li>
                <li><a href="#" @click="deleteRestoreJob(restore, index)"><span class="mif-2x mif-bin icon"></span><span>{{ $t("Delete") }}</span> </a></li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="restores != null && restores.length != 0" class="d-flex flex-justify-between">
        <label class="p-2">
        {{ $t('Page {0} · {1} results', { 0: filters.nPage + 1, 1: restores.length }) }}
        </label>
        <div class="row pr-2 pl-0">
          <div class="col-auto">
            <button
              class="button secondary"
              @click="changePage(filters.nPage - 1)"
              :disabled="filters.offset == 0"
              >
            <span class="mif-arrow-left mr-2"></span>{{ $t('Back') }}
            </button>
          </div>
          <div class="col-auto">
            <button
              class="button secondary"
              @click="changePage(0)"
              :disabled="filters.offset == 0"
              >
            {{ $t('First Page') }}
            </button>
          </div>
          <div class="col-auto">
            <button
              class="button secondary"
              @click="changePage(filters.nPage + 1)"
              :disabled="!has_more"
              >
            {{ $t('Next') }}<span class="mif-arrow-right ml-2"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from './utils/Navigation.vue';
import NoDataAvailable from "./utils/NoDataAvailable.vue";
import { diffDate, prettyBytes } from '../utils/utilitiesmodule';
import PCLink from "../components/utils/PCLink.vue";
import LastResult from "../components/utils/LastResult.vue";

export default {
  name: "Restores",
  components: {
    Navigation,
    NoDataAvailable,
    LastResult,
    PCLink,
  },

  data() {
    return {
      restores: [],
      has_more: false,
      filters: {
        nPage: 0,
        offset: 0,
        limit: 25,
        restoreName: '',
        result: '',
        resultList: [this.$ResultValue.OK, this.$ResultValue.SomeWarnings, this.$ResultValue.Error, this.$ResultValue.Aborted, this.$ResultValue.TerminatedAbnormally],
        id_group: '',
        groupSelected: '',   // oggetto gruppo selezionato
        id_pc: '',
      },
      groups: null,
      computers: [],         // elenco pc completo
      pcsMap: null,
      groupPCs: [],          // pc filtrati per gruppo
      loading: false,
      selectedIndex: -1
    }
  },

  created() {
    this.$session.setRoomPC(null);
    this.$root.socket("SETPC", null);

    this.groups=this.$session.getGroups();
    this.computers=this.$session.getPCList(); // (era commentato)
  },

  mounted() {
    this.getRestores();
    this.pcsMap=this.$session.getPCList().toMap("id");
    this.$root.$on("removeRestoreJobFromList", () => {
      if (this.selectedIndex!=-1)
        this.restores.splice(this.selectedIndex, 1);
      else
        this.restores.removeIf(r => r.id==idRestore);
      this.selectedIndex=-1;
    });
  },
  beforeDestroy() {
    this.$root.$off("removeRestoreJobFromList");
  },

  filters: {
    prettyBytes(bytes, precision) {
      return prettyBytes(bytes, precision);
    },
  },

  methods: {

    diffDate(datestart, dateend) {
      return diffDate(datestart, dateend, this.$moment);
    },

    // Applica i filtri e carica i restores
    getRestores() {
      this.loading=true;
      this.selectedIndex=-1;
      this.filters.offset=this.filters.nPage*this.filters.limit;
      this.$api.getRestores(this.filters)
        .then(result => {
          this.restores.update(result.restore_logs);
          this.has_more=result.has_more;
          this.loading=false;
        })
        .catch(error => {
          console.writeError(error);
          this.loading=false;
        });
    },

    // Aggiorna la lista pc in base al gruppo scelto
    setGroupPCs() {
      const group=this.filters.groupSelected||null;

      // aggiorna subito i campi, così la combo device si abilita
      this.filters.id_group=group? group.id_group:'';
      this.filters.id_pc='';

      if (!group||!Array.isArray(group.ids_computers)||group.ids_computers.length===0) {
        this.groupPCs=[];
        return;
      }

      // filtra pc per id del gruppo
      this.groupPCs=this.computers.filter(c => group.ids_computers.includes(c.id));
    },
    deleteRestoreJob(restoreJob, index) {
      this.selectedIndex=index;

      let self=this;
      this.$root.$on("deleteRestoreJob_feedback", feedback => {

        if (feedback.status==self.$ResultValue.OK) {
          this.restores.splice(index, 1);
          this.$root.$emit("CLOSERESTOREVIEW");
        }

        if (feedback.status!=self.$ResultValue.Running) {
          self.$root.$off("deleteRestoreJob_feedback");
          return;
        }

      });

      this.$root.$emit("deleteRestoreJob", restoreJob);

    },

    openRestoreView(restore, index) {
      this.selectedIndex=index;
      this.$root.$emit('OPENRESTOREVIEW', restore)
    },

    changePage(nPage) {
      this.filters.nPage=nPage;
      this.getRestores();
    }
  }
}
</script>
